import { createAction, createReducer } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  authorized: false,
  profile: null,
  permissions: [],
  representative: null,
  represented: null,
  tokenReturn: null,
  isCredentiated: true,
  canCredentiate: true,
  isAware: true,
  message: null,
};

const setTokenCredentialsAuth = (state, action) => {
  return {
    ...state,
    tokenReturn: action.payload,
  };
};

export const setCredentialsAuth = createAction("AUTH_SET_CREDENTIALS");
export const setPermissions = createAction("AUTH_SET_PERMISSIONS");
export const setProfile = createAction("AUTH_SET_PROFILE");
export const setRepresentative = createAction("AUTH_SET_REPRESENTATIVE");
export const setRepresented = createAction("AUTH_SET_REPRESENTED");
export const setAuthorized = createAction("AUTH_SET_AUTHORIZED");

export default createReducer(INITIAL_STATE, {
  [setCredentialsAuth.type]: (state, action) => {
    return setTokenCredentialsAuth(state, action);
  },
  [setPermissions.type]: (state, action) => ({
    ...state,
    permissions: action.payload,
  }),
  [setProfile.type]: (state, action) => ({
    ...state,
    profile: action.payload,
  }),
  [setRepresentative.type]: (state, action) => ({
    ...state,
    representative: action.payload,
  }),
  [setRepresented.type]: (state, action) => ({
    ...state,
    represented: action.payload,
  }),
  [setAuthorized.type]: (state, action) => ({
    ...state,
    authorized: action.payload,
  }),
});
